import { screenMd, screenSm, screenXlg, screenXs } from 'constants/styles/breakpoints';
import styled from 'styled-components';

export const Container = styled.div<{ noMobile?: boolean }>`
  display: ${({ noMobile }) => (noMobile ? 'none' : 'flex')};
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 20px 30px;
  background-color: #fff;
  border: 1px solid #e9e9ed;
  border-radius: 15px;
  margin-bottom: 65px;
  ${screenSm} {
    display: ${(noMobile) => noMobile && 'flex'};
    min-height: 500px;
  }
  ${screenMd} {
    margin-bottom: 0;
  }
`;

export const CertificationsContainer = styled.div`
  display: flex;
  gap: 15px;
  width: 100%;
  margin-top: 15px;
  flex-direction: column;
  ${screenXlg} {
    flex-direction: row;
  } ;
`;

export const ClearInput = styled.div`
  position: absolute;
  div {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    margin: 10px 0px 0 190px;
    border-radius: 50%;
    transition: background-color 0.3s;
    ${screenXs} {
      margin: 10px 0px 0 210px;
    }
    ${screenSm} {
      margin: 10px 0px 0 57vw;
    }
    ${screenMd} {
      margin: 10px 0px 0 190px;
    }
    &:hover {
      background-color: #fff;
    }
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
`;

export const User = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
  `,
  Name: styled.span`
    font-size: 14px;
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  Email: styled.span`
    font-size: 14px;
    line-height: 16px;
    color: var(--bright-gray);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
};

export const ColumnNameIcon = styled.div`
  margin-right: 2px;
`;

export const PaginationContainer = styled.div`
  width: calc(100% + 13px);
  margin-left: -3px;
`;

export const TeamsContainer = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableScrollWrapper = styled.div`
  overflow-x: auto;
  width: 100%;
  min-width: 0;

  tr {
    column-gap: 0;
    padding-left: 0;
  }

  th:not(:first-child),
  td:not(:first-child) {
    padding-left: 20px;
  }

  th:last-child,
  td:last-child {
    padding-left: 0;
  }

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    z-index: 2;
    background: var(--white);
    align-self: stretch;
    display: flex;
    align-items: center;
    min-width: 0;
    box-sizing: border-box;
    padding-left: 10px;
  }

  td:first-child > * {
    min-width: 0;
    width: 100%;
  }

  th:last-child,
  td:last-child {
    position: sticky;
    right: 0;
    z-index: 2;
    background: var(--white);
    align-self: stretch;
    display: flex;
    align-items: center;
    box-shadow: 2px 0 0 0 var(--white);
  }

  &[data-shadow-left='true'] {
    th:first-child,
    td:first-child {
      box-shadow: 4px 0 8px rgba(0, 0, 0, 0.04);
    }
    td:first-child {
      clip-path: inset(0 -15px 0 0);
    }
  }

  &[data-shadow-right='true'] {
    th:last-child,
    td:last-child {
      box-shadow: 2px 0 0 0 var(--white), -4px 0 8px rgba(0, 0, 0, 0.04);
    }
    td:last-child {
      clip-path: inset(0 -2px 0 -15px);
    }
  }
`;
